import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import OpeningPage from './pages/OpeningPage';
import About from './pages/About';
import Contact from './pages/Contact';
import Parts from './pages/Parts';
import Services from './pages/Services';
import Peterbilt from './pages/Peterbilt';
import Isuzu from './pages/Isuzu';
import McNeilus from './pages/Mcneilus';
import Custom from './pages/CustomTruck';
import Affiliates from './pages/Affliates';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<OpeningPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/peterbilt" element={<Peterbilt/>} />
        <Route path="/isuzu" element={<Isuzu/>} />
        <Route path ="/mcneilus" element={<McNeilus />} />
        <Route path ="/custom-truck" element={<Custom />} />
        <Route path="/parts" element={<Parts/>} />
        <Route path="/service" element={<Services/>} />
        <Route path="/affiliates" element={<Affiliates/>} />
        
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

//<Route path="/affiliates" element={<Affiliates/>} />